var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1688109865749,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 23067,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M833.163636 788.169697H206.351515c-15.515152 0-27.927273 12.412121-27.927273 27.927273v31.030303c0 3.10303 3.10303 6.206061 6.206061 6.20606h670.254545c3.10303 0 6.206061-3.10303 6.206061-6.20606v-31.030303c0-15.515152-12.412121-27.927273-27.927273-27.927273z m-530.618181-71.369697h6.20606l142.739394-24.824242c3.10303 0 3.10303 0 3.10303-3.103031l363.054546-363.054545c3.10303-3.10303 3.10303-9.309091 0-12.412121l-142.739394-139.636364c0-3.10303-3.10303-3.10303-6.206061-3.10303s-3.10303 0-6.20606 3.10303L302.545455 533.721212l-3.103031 3.10303-24.824242 142.739394c-3.10303 15.515152 9.309091 31.030303 24.824242 34.133334 0 3.10303 3.10303 3.10303 3.103031 3.10303z",
    "p-id": 23068,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9c4766c980b8ea33049ae587ae8cfc91.svg";
export { ForwardRef as ReactComponent };